import styled from 'styled-components';
import { Column, Logo } from '@upgrade/react-components';
import { Hero, Section } from '../common/styles';

export const AboutHero = styled(Hero)`
  background-image: url(${({ 'data-image': img }) => img});
  background-size: 140rem 100em;
  @media (max-width: ${props => props.theme.mediaSm}) {
    background-position-y: -4rem;
    background-position-x: -60rem;
  }
  @media (min-width: ${props => props.theme.mediaMd}) {
    background-position-y: -6rem;
  }
`;

export const Title = styled.h1`
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 100%;
`;

/* Why Choose Us */
export const HighlightColumn = styled(Column)`
  @media (max-width: ${props => props.theme.mediaSm}) {
    margin-bottom: 1rem;
  }
`;
export const HighlightContainer = styled.div`
  padding: 1rem;
  text-align: center;
  height: 100%;
`;
export const HighlightTitle = styled.div`
  margin-bottom: 0.5rem;
`;
export const HighlightSubtitle = styled.div`
  color: ${props => props.theme.palette.contentReverse};
  font-weight: 300;
`;
export const WhyChooseUsSection = styled(Section)`
  ${Title} {
    color: ${props => props.theme.palette.contentReverse};
  }
`;

export const TitleLight = styled.h2`
  text-transform: uppercase;
  font-weight: 300;
  letter-spacing: 0.625rem;
  font-size: 1rem;
  margin-bottom: ${({ spaced }) => (spaced ? '4rem' : '1rem')};
  color: inherit;
`;

export const OfficesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
`;

export const Office = styled.div`
  flex: 1 1 50%;
  text-align: center;
  justify-content: center;
  padding: 0 4rem;
  display: flex;
  a {
    display: flex;
    flex-direction: column;
    align-self: flex-end;
  }
  a,
  a:focus,
  a:hover {
    text-decoration: none;
  }
  img {
    margin-bottom: 1rem;
    width: 100%;
  }
`;

export const OurGoalContainer = styled.div`
  text-align: center;
  color: ${props => props.theme.palette.actionablePrimary};
  background-color: ${props => props.theme.palette.backgroundPrimary};
  padding: 4rem 1.25rem;
  opacity: 0.8;

  @media (min-width: ${props => props.theme.mediaMd}) {
    padding: 4rem 11rem;
    margin-left: 10rem;
    margin-right: 10rem;
    p {
      font-size: 1.625rem;
      line-height: 123%;
    }
  }
`;

export const Styledlogo = styled(Logo)`
  width: 14rem;
  height: 12rem;
  margin-bottom: 2rem;
  @media (min-width: ${props => props.theme.mediaMd}) {
    margin-bottom: 0;
  }
`;

export const StyledImage = styled.img`
  width: 100%;
  @media (min-width: ${props => props.theme.mediaSm}) {
    max-width: 40rem;
  }
`;

/* PoweredByUpgrade */
export const StyledPoweredByDescription = styled.p`
  @media (min-width: ${props => props.theme.mediaSm}) {
    padding-left: 20%;
    padding-right: 20%;
  }
`;
export const StyledPoweredByText = styled.div`
  color: ${props => props.theme.palette.content};
  font-size: 0.625rem;
`;
export const StyledPoweredByImage = styled.img`
  width: 8rem;
`;
